import React, {useEffect, useState} from "react";
import "./AddStudentPage.sass"
import ButtonComponent from "../../_components/common/buttons/ButtonComponent";
import CircleButton from "../../_components/common/buttons/CircleButton";
import CloseIcon from "@mui/icons-material/Close";
import TextFieldEdit from "../../_components/common/fields/TextFieldEdit";
import PhoneNumberTextEdit from "../../_components/common/fields/PhoneNumberTextEdit";
import {levels} from "../../common/themes";
import SelectTextEdit from "../../_components/common/fields/SelectTextEdit";
import {useNavigate, useParams} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {setEmpty} from "../../_actions/group/groupReducer";
import _ from "lodash"
import Spinner from "../common/anonymous/Spinner";
import Window from "../../_containers/window/Window";
import {getGroupById, saveStudent} from "../../_actions/group/groupService";
import {InputAdornment} from "@mui/material";

export default function AddStudentPage() {
    const [username, setUsername] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [middleName, setMiddleName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState();
    const [birthDate, setBirthDate] = useState("");
    const [parentFullName, setParentFullName] = useState("");
    const [parentPhoneNumber, setParentPhoneNumber] = useState("");
    const [level, setLevel] = useState(1);
    const [discount, setDiscount] = useState(0);

    const navigate = useNavigate();
    const {id} = useParams();
    const dispatch = useDispatch();

    const {data, status} = useSelector(state => state.groups.selected);
    const {errors, status: saveStudentStatus} = useSelector(state => state.groups.saveStudent);

    useEffect(() => {
        if (status === 'idle') {
            dispatch(getGroupById(id))
        }
    }, [data, status, dispatch]);
    useEffect(() => {
        document.title = 'КьюАй - Добавление ученика'
        return () => {
            dispatch(setEmpty())
        }
    }, [])

    if (status === 'idle' || status === 'loading' || saveStudentStatus === 'loading') {
        return <Spinner/>
    }

    if (saveStudentStatus === 'succeeded') {
        return (
            <Window>
                <div className="AddStudentPage-header">
                    <div className="AddStudentPage-title">Добавление ученика</div>
                </div>
                <div className="AddStudentPage-message">
                    <div className="AddStudentPage-message-text">
                        Ученик добавлен в группу!<br/>
                        На указанную почту ученика было отправлено
                        сообщение с логином и паролем.
                    </div>
                </div>
                <div className="AddStudentPage-footer">
                    <ButtonComponent onClick={() => navigate(`/home/group/${id}`)}>
                        Назад
                    </ButtonComponent>
                </div>
            </Window>
        )
    }

    const handleChangeDiscount = (value) => {
        const r = /[0-9]/g;
        if (value === '') {
            setDiscount(0);
        } else {
            if (r.test(value) && parseInt(value) >= 0) {
                if (parseInt(value) > 100) {
                    setDiscount(100);
                } else {
                    setDiscount(value)
                }
            }
        }
    }

    const handleSave = () => {
        const body = {
            username,
            firstName,
            lastName,
            middleName: _.isEmpty(middleName) ? null : middleName,
            // phoneNumber: 37544369852147,
            phoneNumber: phoneNumber && phoneNumber.match(/\d/g).join(""),
            birthDate,
            parentFullName,
            // parentPhoneNumber: "375369852147",
            parentPhoneNumber: parentPhoneNumber && parentPhoneNumber.match(/\d/g).join(""),
            level: 1,
            group: {id: data.id},
            discount: {discount: discount}
        }
        dispatch(saveStudent(body))
    }

    const renderField = (Component, isRequired, label, value, setValue, error, props) => {
        return <Component required={isRequired}
                          {...props}
                          value={value}
                          error={!!error}
                          helperText={error}
                          onChange={e => setValue(e.target.value)}
                          label={label}/>
    }

    return (
        <Window>
            <div className="AddStudentPage-header">
                <div className="AddStudentPage-title">Добавление ученика</div>
                <div className="AddStudentPage-close">
                    <CircleButton Icon={CloseIcon} title="Закрыть" onClick={() => navigate(`/home/group/${id}`)}/>
                </div>
            </div>
            <div className="AddStudentPage-fields">
                {renderField(TextFieldEdit, true, "Эл. почта", username, setUsername, errors && errors.username)}
                {renderField(TextFieldEdit, true, "Имя", firstName, setFirstName, errors && errors.firstName)}
                {renderField(TextFieldEdit, true, "Фамилия", lastName, setLastName, errors && errors.lastName)}
                {renderField(TextFieldEdit, false, "Отчество", middleName, setMiddleName, errors && errors.middleName)}
                {renderField(PhoneNumberTextEdit, true, "Номер телефона", phoneNumber, setPhoneNumber, errors && errors.phoneNumber)}
                {renderField(TextFieldEdit, true, "День рождения", birthDate, setBirthDate, errors && errors.birthDate, {
                    type: "date",
                    InputLabelProps: {shrink: true}
                })}
                {renderField(TextFieldEdit, true, "ФИО родителя", parentFullName, setParentFullName, errors && errors.parentFullName)}
                {renderField(PhoneNumberTextEdit, true, "Номер телефона родителя", parentPhoneNumber, setParentPhoneNumber, errors && errors.parentPhoneNumber)}
                {renderField(SelectTextEdit, true, "Уровень", level, setLevel, errors && errors.level, {data: levels})}
                {renderField(TextFieldEdit, false, "Скидка, %", discount, handleChangeDiscount, errors && errors["discount.discount"],
                    {
                        type: "number",
                        InputProps: {endAdornment: <InputAdornment position="end">%</InputAdornment>},
                        inputProps: {min: 0, max: 100}
                    })}
                <div>
                    <span>Стоимость занятия: </span><span>{(parseInt(data.cost) * (100 - discount) / 10000).toFixed(2)} рублей</span>
                </div>
            </div>
            <div className="AddStudentPage-footer">
                <ButtonComponent onClick={handleSave}>
                    Добавить
                </ButtonComponent>
            </div>
        </Window>
    )
}